import React from "react";
import Judge from "../../components/Judge/Judge";
import PageTitle from "../../components/PageTitle/PageTitle"
import {JudgeData} from './JudgeData'
import styles from "./Judges.module.scss";

const Judges = () => {
  return (
    <div>
      <PageTitle> Judges 2025 </PageTitle>
      <p className={styles["lead"]}>
        Each year the Comms National Awards assembles a panel of industry experts that can draw on impressive industry tenure to ensure judging of the highest standards. The collective cohort represents multiple facets of our industry – including finance & M&A, HR and recruitment and MSP leadership – to address the breadth of categories this awards process offers. Our judges pledge impartiality and discretion before agreeing to join the panel. 
      </p>
      <h2 className={styles["sub-title"]}>Meet 2025's CNA judges below</h2>
      
      <Judge profiles={JudgeData} />
    </div>
  );
};

export default Judges;
